export default __webpack_public_path__ + "static/media/logo_SVS_short.b86af841.svg";